import axios from "axios";
import Cookies from "js-cookie";
import subCategories from "../pages/subCategoriesPage";


const BASE_URL = import.meta.env.VITE_BASE_URL;

const api = axios.create({
  baseURL: BASE_URL,
    
});

// ✅ Automatically attach token from cookies
api.interceptors.request.use((config) => {
  const jwt = Cookies.get("jwt"); 
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  console.log("➡️ Request:", config.url, config.headers);

  return config;
});


export const Apis = {
  auth: {
    login: "/admin/auth/login",
    LogOut:"/auth/logout",
    forgotPassword:"/admin/auth/forgot-password",
    otp:"/admin/auth/verify-otp",
    resetPassword:"/admin/auth/reset-password",
  },
  contact:{
  list:"/contact-us/list"
  },
  testimonial:{
  add:"/testimonials/add",
  all:"/testimonials/all",
  update: (id: string) => `/testimonials/update/${id}`,
  delete:(id: string) => `/testimonials/delete/${id}`,
  },
category: {
  add: "/category/add",
  list: "/category/list",
  update: (uid: string) => `/category/update/${uid}`,
 "delete": (uid: string) => `/category/${uid}` ,
 subCategories:"/category/subcategories"
},
review:{
  all:"/review/get-all-for-admin",
  update: (uid: string) => `/review/status-update/${uid}`,
},
email:{
add:"/admin-email",
get:"/admin-email"
},
product: {
  add: "/product/add",
  list: "/product/get-all-products",
  update: (uid: string) => `/product/update/${uid}`,
  updateStatus: (uid: string) => `/product/update-status/${uid}`,
  delete: (uid: string) => `/product/delete/${uid}`,
},
  customer:{
    list:"/user/list",
    block: (uid: string, action: string) => `/user/${uid}/status?action=${action}`,
  },
  content:{
  addBanner:"/banner/add",
  getBanner:"/banner/all",
   "delete": (uid: string) => `/banner/delete/${uid}`, // ✅ quotes around delete
    toggleStatus: (uid: string, status: string) => `banner/${uid}/status?status=${status}`,
      update: (uid: string) => `/banner/update/${uid}`,   // ✅ add this 
  },
  addVideo:{
  add:"/video/add",
  list:"/video/get-for-user",
  update: (uid: string) => `/video/update/${uid}`,
  delete:(uid: string) => `/video/delete/${uid}`,
  },
  reward:{
  addReward:"/reward/add",
  editReward:"/reward/edit",
  getReward:"/reward/get",
  },
  image:{
   addImage:"/files/upload",
   multiple:"/upload/multiple",
  },
  ingredient:{
    add:"/ingredient/add ",
    get:"ingredient/all ",
  },
  order:{
    list:"/orders/list",
    statusChange:"orders/status-change"
  },
  shipping:{
    add:"/payment/setting/save",
    get:"/payment/setting/get",
  },
  user: {
    getByUid: (uid: string) => `/user/get/${uid}`,
  },
  address: {
    getByUid: (uid: string) => `/address/get/${uid}`,
  },
  report:{
    get:"/report/orders",
  },
  cancleReport:{
    get:"/report/cancelled-orders"
  }

};

export default api;
